/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Globalinfo1Inputs */

const en_settings_globalinfo1 = /** @type {(inputs: Settings_Globalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These settings are applied to all users in your organization.`)
};

const de_settings_globalinfo1 = /** @type {(inputs: Settings_Globalinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Einstellungen gelten für alle Benutzer in Ihrer Organisation.`)
};

/**
* | output |
* | --- |
* | "These settings are applied to all users in your organization." |
*
* @param {Settings_Globalinfo1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const settings_globalinfo1 = /** @type {((inputs?: Settings_Globalinfo1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Globalinfo1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_globalinfo1(inputs)
	return de_settings_globalinfo1(inputs)
});
export { settings_globalinfo1 as "settings_globalInfo" }